import type { ActivityType } from '../../../typings'
import type { State } from '../../typings'

export const updateActivityTypeProducer = (
  state: State,
  payload?: ActivityType,
) => {
  const activityTypes = state.activityTypes.map((activity) =>
    payload && activity.id === payload.id ? payload : activity,
  )

  return {
    ...state,
    isOpen: true,
    current: payload ? payload : state.current,
    activityTypes,
  }
}
